import { FC } from "react";
import currencyToLocale from "@/lib/currencyToLocale";
import { cn } from "@/lib/utils";

interface PriceDisplayProps {
  amount: number | string | undefined | null;
  currency?: string;
  className?: string;
}

const PriceDisplay: FC<PriceDisplayProps> = ({ amount, currency = "USD", className }) => {
  if (!amount) return null;

  // Convertir le montant en nombre si c'est une chaîne
  const amountNumber = typeof amount === "string" ? parseFloat(amount) : amount;

  // Déterminer la locale basée sur la devise
  const locale = currencyToLocale[currency] || "en-US";

  // Formatage du montant
  const formattedPrice = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amountNumber);

  return <span className={cn("italic", className)}>{formattedPrice}</span>;
};

export default PriceDisplay;
